import { render, staticRenderFns } from "./queryPay.vue?vue&type=template&id=6d563f58"
import script from "./queryPay.vue?vue&type=script&lang=js"
export * from "./queryPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports